const timezone = (state = 'Poland', action) => {
  switch (action.type) {
    case 'SET_TIMEZONE':
      return action.payload;
    default:
      return state;
  }
};

export default timezone;
